import React, {Fragment, lazy, Suspense, Component} from 'react';
import PropTypes from 'prop-types';
import * as dotenv from 'dotenv';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {FacebookProvider} from 'react-facebook';
import {AnimationProvider, RelaxComponentsProvider} from 'd-relax-components';
import {ResponsiveProvider, Styled} from 'd-components-core';
import {CookiesProvider} from 'react-cookie';
import {AuthConsumer, AuthProvider} from './contexts/AuthContext';
import {UserConsumer, UserProvider} from './contexts/UserContext';
import CacheBuster from './CacheBuster';
import createAuthenticatedApolloClient from './graphql/createAuthenticatedApolloClient';
import {ApolloProvider} from '@apollo/react-hooks';
import * as theme from './theme';
import PageLoader from './components/PageLoader/index';
import 'd-components-core/dist/assets/style.css';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const facebookAppID = process.env.REACT_APP_FACEBOOK_APP_ID;

dotenv.config();
const history = createBrowserHistory();

const loadAuthenticatedApp = () => import('./AuthenticatedApp');
const AuthenticatedApp = lazy(loadAuthenticatedApp);

export default class App extends Component {
    render() {
        return (
            <CacheBuster>
                {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                    if (loading) return null;
                    if (!loading && !isLatestVersion) {
                        // You can decide how and when you want to force reload
                        refreshCacheAndReload();
                    }

                    return (
                        <Router history={history}>
                            <Fragment>
                                <RelaxComponentsProvider theme={theme}>
                                    <ResponsiveProvider>
                                        <AnimationProvider>
                                            <Suspense fallback={<PageLoader/>}>
                                                <CookiesProvider>
                                                    <AuthProvider authenticationService={this.props.authenticationService}>
                                                        <AuthConsumer>
                                                            {({isAuth, logout, errorMessage, redeemedCampaignCode, cookies}) => {
                                                                const apolloClient = createAuthenticatedApolloClient({
                                                                    authenticationService: this.props.authenticationService,
                                                                    logout,
                                                                    cookies
                                                                });
                                                                return (
                                                                    <ApolloProvider client={apolloClient} logout={logout}>
                                                                        <UserProvider
                                                                            cookies={cookies}
                                                                            authenticationService={this.props.authenticationService}
                                                                        >
                                                                            <UserConsumer>
                                                                                {({currentUser}) => {
                                                                                    return (
                                                                                        <FacebookProvider appId={facebookAppID} xfbml status cookie>
                                                                                            <div className="wrapper">
                                                                                                <ToastContainer
                                                                                                    className="toast-container-wrap"
                                                                                                    toastClassName="toast-wrap"
                                                                                                />
                                                                                                <AuthenticatedApp
                                                                                                    isAuthenticated={isAuth}
                                                                                                    currentUser={currentUser}
                                                                                                    cookies={cookies}
                                                                                                    logout={logout}
                                                                                                    history={history}
                                                                                                    errorMessage={errorMessage}
                                                                                                    redeemedCampaignCode={redeemedCampaignCode}
                                                                                                    authenticationService={this.props.authenticationService}
                                                                                                />
                                                                                            </div>

                                                                                        </FacebookProvider>
                                                                                    );
                                                                                }}

                                                                            </UserConsumer>
                                                                        </UserProvider>
                                                                    </ApolloProvider>
                                                                );
                                                            }}
                                                        </AuthConsumer>
                                                    </AuthProvider>
                                                </CookiesProvider>
                                            </Suspense>
                                        </AnimationProvider>
                                        <Styled/>
                                    </ResponsiveProvider>
                                </RelaxComponentsProvider>
                            </Fragment>
                        </Router>);
                }}
            </CacheBuster>
        );
    }
}

App.propTypes = {
    authenticationService: PropTypes.object.isRequired,
};
